import { Controller } from "@hotwired/stimulus"

// Submits the form the moment one of its inputs changes. Used by the WebAugment
// Service settings page so each on/off switch applies immediately (via Turbo
// Stream) without a Save button.
//
// For search-as-you-type filter forms use `debouncedSubmit`: it waits
// `delayValue` ms after the last change and, for text-like inputs, skips
// values shorter than `minLengthValue` characters (an emptied field still
// submits, so clearing the input resets the filter).
export default class extends Controller {
  static values = {
    delay: { type: Number, default: 300 },
    minLength: { type: Number, default: 3 }
  }

  submit() {
    this.element.requestSubmit()
  }

  debouncedSubmit(event) {
    clearTimeout(this.timer)

    const target = event.target
    if (this.#isTextual(target)) {
      const length = target.value.trim().length
      if (length > 0 && length < this.minLengthValue) return
    }

    this.timer = setTimeout(() => this.element.requestSubmit(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  #isTextual(input) {
    return input instanceof HTMLInputElement && ["text", "search", "email"].includes(input.type)
  }
}
